import styles from "../Carousel.module.css";
import type { AffixProps } from "../types";

const { affix } = styles;

export const Affix = (props: AffixProps) => {
  const {
    position = "left",
    action = "next",
    handleAffixAction,
    children,
    block,
  } = props;

  if (!children) return null;

  return (
    <button
      className={affix}
      data-position={position}
      data-block={block}
      onClick={() => handleAffixAction?.(action)}
    >
      {children}
    </button>
  );
};
